import React from "react";

import { makeKey } from "../../../../utils/helpers";

import {
  BriefListContainer,
  BriefListItem,
  BriefName,
} from "./campaign-briefs-search-results.styles";
import { CampaignBriefsSearchResultsProps } from "./campaign-briefs-search-results.props";

export const CampaignBriefsSearchResults = (props: CampaignBriefsSearchResultsProps) => {
  if (!props.briefs.length) {
    return null;
  }

  return (
    <BriefListContainer className={props.styleClass}>
      {props.briefs.map((brief) => (
        <BriefListItem
          key={makeKey("user", brief.id)}
          onClick={() => {
            props.handleSelect(brief);
          }}
        >
          <BriefName>{brief.name}</BriefName>
        </BriefListItem>
      ))}
    </BriefListContainer>
  );
};
